import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { fmtDateTime, formatINR } from "@/lib/format";
import { PageHead, Pill, In, Sel } from "@/components/admin/kit";
import { Loading, Empty } from "@/components/site/Primitives";

export const PROJECT_STATUSES = ["Awaiting Assets", "Awaiting Payment or Approval", "Ready to Assign", "In Progress", "Internal Quality Check",
  "First Draft Delivered", "Revision Requested", "Final Quality Check", "Completed", "On Hold", "Cancelled"];

const deadlineTone = (p) => {
  if (!p.first_draft_deadline || ["Completed", "Cancelled", "First Draft Delivered"].includes(p.status)) return "text-zinc-400";
  const ms = new Date(p.first_draft_deadline) - Date.now();
  return ms < 0 ? "text-red-400" : ms < 864e5 ? "text-amber-300" : "text-zinc-300";
};

export default function Projects() {
  const nav = useNavigate();
  const [items, setItems] = useState(null);
  const [q, setQ] = useState("");
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  useEffect(() => {
    setItems(null);
    api.get("/admin/projects", { params: { q: search, status } }).then((r) => setItems(r.data));
  }, [search, status]);
  return (
    <div data-testid="admin-projects">
      <PageHead eyebrow="Operations" title="Projects" />
      <div className="grid md:grid-cols-4 gap-3 mb-6">
        <form className="md:col-span-2" onSubmit={(e) => { e.preventDefault(); setSearch(q); }}><In value={q} onChange={setQ} placeholder="Search reference or client" testid="projects-search" /></form>
        <Sel value={status} onChange={setStatus} options={PROJECT_STATUSES} placeholder="All statuses" testid="projects-filter-status" />
      </div>
      {!items ? <Loading rows={1} /> : items.length === 0 ? <Empty title="No projects yet." body="Projects are created from enquiries with an accepted quote." /> : (
        <div className="overflow-x-auto border border-[#27272A]">
          <table className="w-full text-sm" data-testid="projects-table">
            <thead><tr className="text-left text-xs uppercase tracking-wider text-zinc-500 border-b border-[#27272A]">
              {["Reference", "Client", "Scope", "Total", "Editor", "First draft due", "Status"].map((h) => <th key={h} className="px-4 py-3 font-medium">{h}</th>)}
            </tr></thead>
            <tbody>
              {items.map((p) => (
                <tr key={p.id} onClick={() => nav(`/admin/projects/${p.id}`)} className="border-b border-[#27272A] last:border-0 hover:bg-[#121212] cursor-pointer" data-testid={`project-row-${p.reference}`}>
                  <td className="px-4 py-3 font-mono text-[#00E5FF] whitespace-nowrap">{p.reference}</td>
                  <td className="px-4 py-3"><p>{p.client.name}</p><p className="text-xs text-zinc-500">{p.client.company}</p></td>
                  <td className="px-4 py-3 max-w-[260px] truncate">{p.scope.title}</td>
                  <td className="px-4 py-3 whitespace-nowrap">{formatINR(p.totals?.total)}</td>
                  <td className="px-4 py-3 text-zinc-400">{p.assigned_editor || "—"}</td>
                  <td className={`px-4 py-3 whitespace-nowrap ${deadlineTone(p)}`}>{p.first_draft_deadline ? fmtDateTime(p.first_draft_deadline) : "Clock not started"}</td>
                  <td className="px-4 py-3"><Pill status={p.status} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
